module.exports = __webpack_public_path__ + "img/img-sample-question.18622969.jpg";